import validate from "/usr/src/app/content/n3-spas-1b1ba29e-96fc-4f19-a29b-7e45a51bfb9a/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-1b1ba29e-96fc-4f19-a29b-7e45a51bfb9a/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}